// src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import translation files
import translationEN from './locales/en/translation.json';
import translationNL from './locales/dutch/translation.json';
import translationAR from './locales/arabic/translation.json';

// Define the resources
const resources = {
  english: {
    translation: translationEN
  },
  dutch: {
    translation: translationNL
  },
  arabic: {
    translation: translationAR
  }
};

// Initialize i18next
i18n
  .use(initReactI18next) // Passes i18n down to react-i18next
  .init({
    resources,
    lng: 'dutch', // Default language
    fallbackLng: 'dutch',

    interpolation: {
      escapeValue: false // React already safeguards from XSS
    }
  });

/*
// Handle RTL languages by adding a class
i18n.on('languageChanged', (lng) => {
  if (lng === 'arabic') {
    document.documentElement.classList.add('rtl');
  } else {
    document.documentElement.classList.remove('rtl');
  }
});
*/

export default i18n;
